import React from 'react';
import { useForm } from 'react-hook-form';

const Contact = ({ MarginTop }) => {
  const { register, handleSubmit, formState: { errors }, } = useForm();

  return (
    <section id="contact" style={{ scrollMarginTop: MarginTop }}>
      <div className='home-section our_services_sec'>
        <h2 className='title'>Contact & Support</h2>

        <form>
          <div className='row'>
            <div className="col-md-6">
              <div className="dash-fm-group">
                <label className="dash-fm-label" >
                  Name <span className='important_star'>*</span>
                </label>
                <input
                  {...register('name', { required: 'Name is required' })}
                  placeholder='Enter Name'
                  className=''
                />
                {errors?.name?.message && <p className='error-message'>{errors?.name?.message}</p>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="dash-fm-group">
                <label className="dash-fm-label" >
                  Email <span className='important_star'>*</span>
                </label>
                <input
                  {...register('email', { required: 'Email is required' })}
                  placeholder='Enter Email'
                  className=''
                />
                {errors?.email?.message && <p className='error-message'>{errors?.email?.message}</p>}
              </div>
            </div>
            <div className="col-md-12">
              <div className="dash-fm-group">
                <label className="dash-fm-label" >
                  Write a Message <span className='important_star'>*</span>
                </label>
                <textarea
                  style={{ width: '100%', height: '150px', padding: '10px', borderRadius: "4px", fontSize:'13px' }}
                  {...register('message', { required: 'Message is required' })}
                  placeholder='Write a Message'
                  disabled={false}
                  className=''
                />
                {errors?.message?.message && <p className='error-message'>{errors?.message?.message}</p>}
              </div>
            </div>
          </div>
          <button className='sub-btn' onClick={handleSubmit((data) => console.log(data))}>Submit</button>
        </form>
        <div style={{ marginTop: "20px" }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.2361311045374!2d76.97469168456355!3d11.0209021611494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859af9302ac01%3A0x9b990afe6c9ea013!2sAstral%20Consulting%20Ltd!5e0!3m2!1sen!2sin!4v1752660315276!5m2!1sen!2sin"
            width="100%"
            height="450"
            loading="lazy"
            allowFullScreen=""
            referrerPolicy="no-referrer-when-downgrade"
            title="BWE Office Location Map"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;